export async function loadConfig() {
    const host = window.location.hostname;
    const subdomain = host.split('.')[0];
    const configFile = `/config/${subdomain}.json`;

    const res = await fetch(configFile);
    if (!res.ok) {
        console.warn(`⚠️ No se encontró configuración para ${domain}`);
        return {};
    }

    return await res.json();
}

export function applyConfigToHTML(config) {
    if (!config) return;
    
    if (config.url_title) {
        document.title = config.url_title;
    }

    const metaUpdates = {
        'description': config.url_description,
        'og:title': config.url_title,
        'og:description': config.url_description,
        'og:image': config.url_image,
        'og:site_name': config.url_title,
        'og:url': window.location.href
    };
    
    Object.keys(metaUpdates).forEach(key => {
        if (metaUpdates[key]) {
            const selector = key.startsWith('og:') 
                ? `meta[property="${key}"]` 
                : `meta[name="${key}"]`;
            
            const element = document.querySelector(selector);
            if (element) {
                element.setAttribute('content', metaUpdates[key]);
            }
        }
    });
    
    if (config.fav_icon) {
        const favicon = document.getElementById('favicon');
        if (favicon) {
            favicon.href = config.fav_icon;
        }
    }
    
    if (config.url_title) {
        const alternateName = document.querySelector('meta[itemprop="alternateName"]');
        if (alternateName) {
            alternateName.setAttribute('content', config.url_title);
        }
    }
    
    window.appConfig = config;
}
